import { createFileRoute } from '@tanstack/react-router'

import { OptimizationPage } from '@/components/Optimization/OptimizationPage'

/** Wiring only. The page keeps no state worth putting in the URL. */
export const Route = createFileRoute('/_app/marketing/optimization/')({
  component: OptimizationPage,
})
